import {ValidationResponseObj} from '../../../../generated/generated-core.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DISPATCHER_PREFIX} from '../../../consts/data-service-consts';
import {Observable} from 'rxjs';

export interface DataValidator<T> {
    validate(pt: T, url?: string): Observable< null | ValidationResponseObj>;
}

@Injectable({
    providedIn: 'root'
})
export class MxObjectFormValidatorService implements DataValidator<any> {

    constructor(private httpClient: HttpClient) {
    }

    validate(obj: any, url?: string): Observable<ValidationResponseObj> {
        return this.httpClient.post<ValidationResponseObj>(DISPATCHER_PREFIX + url + '/validate', obj);
    }
}
